/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_What_Is_Json_H1Inputs */

const en_guide_what_is_json_h1 = /** @type {(inputs: Guide_What_Is_Json_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`What is JSON? A Complete Beginner's Guide`)
};

const ko_guide_what_is_json_h1 = /** @type {(inputs: Guide_What_Is_Json_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSON이란? 초보자를 위한 완벽 가이드`)
};

const ja_guide_what_is_json_h1 = /** @type {(inputs: Guide_What_Is_Json_H1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`JSONとは？初心者向け完全ガイド`)
};

/**
* | output |
* | --- |
* | "What is JSON? A Complete Beginner's Guide" |
*
* @param {Guide_What_Is_Json_H1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_what_is_json_h1 = /** @type {((inputs?: Guide_What_Is_Json_H1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_What_Is_Json_H1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_what_is_json_h1(inputs)
	if (locale === "ko") return ko_guide_what_is_json_h1(inputs)
	return ja_guide_what_is_json_h1(inputs)
});